import { Module, VuexModule, Action, Mutation } from "vuex-module-decorators";
import { store } from "commonui";
import { IUnitListManager, UnitListManagerService, VCSLevelUnitResponseModel } from "@/services/text-guardian/unit-list";

@Module({ namespaced: true, name: "UnitState", store: store, dynamic: true })
export default class UnitState extends VuexModule {
	unitListManager: IUnitListManager = UnitListManagerService();
	units: VCSLevelUnitResponseModel[] = [];

	@Mutation
	setUnits(units: VCSLevelUnitResponseModel[]) {
		this.units = units;
	}

	@Action
	async fetchUnits(params?: any) {
		const units = await this.unitListManager.getVCSLevelUnits(params);
		this.setUnits(units);
	}
}